import type { AssetsShareUser } from '@iconik-io/iconik-api/src/services/assets';

import { updateEntities } from '../entities/slice';
import { createAppThunk } from '../types';

export const addUserToShare = createAppThunk(
  (shareId: string, data: AssetsShareUser) => (dispatch, getState) => {
    const state = getState();
    const share = shareId ? state.entities.shares[shareId] : undefined;

    const users = [...(share?.users ?? []), data];

    dispatch(
      updateEntities({
        shares: {
          [shareId]: {
            users,
          },
        },
      }),
    );
  },
);

export const deleteUserFromShare = createAppThunk(
  (shareId: string, data: AssetsShareUser) => (dispatch, getState) => {
    const state = getState();
    const share = shareId ? state.entities.shares[shareId] : undefined;

    const users = share?.users?.filter(
      (user) => user.id !== data.id || user.email !== data.email,
    );

    dispatch(
      updateEntities({
        shares: {
          [shareId]: {
            users,
          },
        },
      }),
    );
  },
);
